import React, { useEffect, useState } from 'react';
import { LoadingSpinner } from '@qualtrics/ui-react';
import { isEvaluationExperienceEnabled } from '../services/featureFlipperService';
import { doesStudentExist } from '../services/studentService';
import NonEvaluationExperienceStudentPortal from '../NonEvaluationExperienceStudentPortal/nonEvaluationExperienceStudentPortal';
import EvaluationExperienceStudentPortal from '../EvaluationExperienceStudentPortal/evaluationExperienceStudentPortal';
import UnauthorizedStudentPortal from '../UnauthorizedStudentPortal/unauthorizedStudentPortal';
import styles from './studentPortal.module.css';

const brandId = document.getElementById('bId').textContent;
const hashedStudentId = document.getElementById('uId').textContent;

const StudentPortal = () => {
  const [isEvaluationExperience, setIsEvaluationExperience] = useState(undefined);
  const [isStudentFound, setIsStudentFound] = useState(undefined);

  useEffect(() => {
    const getEvaluationExperienceFeatureFlipper = async () => {
      const isEvalExperienceEnabledForBrand = await isEvaluationExperienceEnabled(brandId);
      setIsEvaluationExperience(isEvalExperienceEnabledForBrand);
    }
    const getDoesStudentExist = async () => {
        const isStudentFound = await doesStudentExist(hashedStudentId, brandId);
        setIsStudentFound(isStudentFound);
    }

    getDoesStudentExist();
    getEvaluationExperienceFeatureFlipper();
  }, []);

  if (isStudentFound === undefined) {
    return (
      <div className={styles['container']}>
        <LoadingSpinner show size="large" className={styles['spinner']}/> 
      </div>
    );
  }

  if (!isStudentFound) {
    return <UnauthorizedStudentPortal />
  }

  if (isEvaluationExperience === undefined) {
    return (
      <div className={styles['container']}>
        <LoadingSpinner show size="large" className={styles['spinner']}/> 
      </div>
    );
  }
  
  if (isEvaluationExperience) {
    return <EvaluationExperienceStudentPortal />
  }

  return <NonEvaluationExperienceStudentPortal />
};

export default StudentPortal;